export default __webpack_public_path__ + "static/media/logo-bayadIP@2x.f2908036.png";